export const SMARTY_STREETS_KEY = '421007431137765';
export const AMPLITUDE_KEY_PROD = 'a55a37a212024ad62e933b63270830aa';
export const AMPLITUDE_KEY_STAGING = '887c7f25061624ccc970005c608ceb44';
export const STRIPE_API_KEY_PROD = 'pk_live_lcAXfmHJgcCFT3fnIs4id7g7';
export const STRIPE_API_KEY_STAGING = 'pk_test_pu8LyOwwUzSbwOFy8mo4W1J2';
export const SPLIT_API_KEY_DEV = 'hbovpdg2f1j8ahfdqdvtsf8ch3oieatustep';
export const SPLIT_API_KEY_PROD = '8ps2845ia2j8koqpc9k0918kiab0kepbud2g';
